import React, { useEffect } from 'react';
import { Reveal } from './Reveal';
const WISTIA_MEDIA_ID = '4haa6zoj40';
const SCRIPTS: {
  src: string;
  module?: boolean;
}[] = [{
  src: 'https://fast.wistia.com/player.js'
}, {
  src: `https://fast.wistia.com/embed/${WISTIA_MEDIA_ID}.js`,
  module: true
}];
function useWistia() {
  useEffect(() => {
    SCRIPTS.forEach(({
      src,
      module
    }) => {
      if (document.querySelector(`script[src="${src}"]`)) return;
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      if (module) script.type = 'module';
      document.head.appendChild(script);
    });
  }, []);
}
export function Vsl() {
  useWistia();
  return <section className="border-b border-white/10 bg-ink-900" aria-labelledby="vsl-title" data-id="element-130" data-mp="2txj2nm1fol59">
      <div className="mx-auto max-w-4xl px-6 py-24 lg:py-28" data-id="element-131" data-mp="ukev96qp39sg">
        <Reveal className="text-center" data-id="element-132" data-mp="ulydv3ztpwxe">
          <p className="text-xs uppercase tracking-[0.18em] text-accent" data-id="element-133" data-mp="zji3t15vvy56">
            9 minutos, sin diapositivas
          </p>
          <h2 id="vsl-title" className="mx-auto mt-6 max-w-2xl text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-134" data-mp="2b3qfoaj6ub8w">
            Por qué tu marca paga hasta 3 veces más por cada cliente que la
            competencia que vende el mismo suplemento.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-zinc-400" data-id="element-135" data-mp="1xdn185qjvlu0">
            La respuesta no está en la puja ni en el público. Está en una
            ecuación que casi ninguna agencia mira antes de subir presupuesto.
            Te la desgloso con números reales en el vídeo.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-12" data-id="element-136" data-mp="2l3hf8qmlvgfu">
          <div className="overflow-hidden border border-white/10 bg-ink-950" data-id="element-137" data-mp="2g1iabcb7wbgs">
            <style data-id="element-138" data-mp="19n0v4k03wbmn">{`
              wistia-player[media-id='${WISTIA_MEDIA_ID}']:not(:defined) {
                background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${WISTIA_MEDIA_ID}/swatch');
                display: block;
                filter: blur(5px);
                padding-top: 56.25%;
              }
              wistia-player[media-id='${WISTIA_MEDIA_ID}'] { display: block; }
            `}</style>
            {React.createElement('wistia-player', {
            'media-id': WISTIA_MEDIA_ID,
            aspect: '1.7777777777777777'
          })}
          </div>
        </Reveal>
      </div>
    </section>;
}